function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import AdvancedDanmakuPanelEditor from './advancedDanmakuPanelEditor';
import AdvancedDanmakuJsonEditor from './advancedDanmakuJsonEditor';
var AdvancedDanmakuEditor = function () {
    function AdvancedDanmakuEditor(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, AdvancedDanmakuEditor);
        this.player = player;
        this.el = el;
        var $ = this.el.querySelector.bind(this.el);
        this.view = {
            editor_panel: $('.mfunsPlayer-ade-panel'),
            editor_json: $('.mfunsPlayer-ade-json'),
            mode_selector: $('.mfunsPlayer-ade-mode-selector'),
            label_panel: $('.mfunsPlayer-ade-mode-selector .label-panel'),
            label_json: $('.mfunsPlayer-ade-mode-selector .label-json')
        };
        this.panelEditor = new AdvancedDanmakuPanelEditor(this.player, this.view.editor_panel);
        this.jsonEditor = new AdvancedDanmakuJsonEditor(this.player, this.view.editor_json);
        this.init();
    }
    _createClass(AdvancedDanmakuEditor, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                this.view.label_panel.addEventListener('click', function () {
                    _this.switchEditorMode('panel');
                });
                this.view.label_json.addEventListener('click', function () {
                    var _this$jsonEditor$edit;
                    _this.switchEditorMode('json');
                    if (!_this.jsonEditor.editor) {
                        _this.jsonEditor.createEditor();
                    }
                    (_this$jsonEditor$edit = _this.jsonEditor.editor) === null || _this$jsonEditor$edit === void 0 ? void 0 : _this$jsonEditor$edit.focus();
                });
            }
        },
        {
            key: 'switchEditorMode',
            value: function switchEditorMode(mode) {
                this.el.classList.toggle('mode-panel', mode == 'panel');
                this.el.classList.toggle('mode-json', mode == 'json');
            }
        }
    ]);
    return AdvancedDanmakuEditor;
}();
export default AdvancedDanmakuEditor;